import React, { useState } from 'react';
import axios from 'axios';

function Employabilite() {
  const [formData, setFormData] = useState({
    societe: '',
    demande: '',
    expert: '',
    autreTexte: '',
  });

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name !== 'autreTexte' && value !== 'autre' ? { autreTexte: '' } : {}),
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/employabilite`, formData);
    setFormData({ societe: '', demande: '', expert: '', autreTexte: '' });
    setShowModal(true); // afficher le popup
  } catch (err) {
    alert("❌ Erreur lors de l’envoi du formulaire.");
  }
};


  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* Modal Popup */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '400px',
            textAlign: 'center',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)'
          }}>
            <h3 style={{ color: '#155724' }}>✅ Message envoyé</h3>
            <p>Nous vous enverrons la suite par email.</p>
            <button
              onClick={closeModal}
              style={{
                marginTop: '1rem',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                padding: '0.5rem 1rem',
                cursor: 'pointer'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Page principale */}
      <div style={{
        marginTop: '5rem',
        padding: '2rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '3rem',
        flexWrap: 'wrap',
      }}>
        {/* Description */}
        <div style={{
          flex: '1',
          minWidth: '280px',
          maxWidth: '400px',
          color: '#333',
          lineHeight: '1.6',
        }}>
          <h2 style={{ marginBottom: '1rem' }}>Partenariat Employabilité</h2>
          <p>
            Hoag Target est en cours de développement d'un plateforme qui aide les jeunes à l'Employabilité.
            Êtes-vous intéressé(e) à devenir notre partenaire ?
          </p>
          <p>
            Cette démarche vise à renforcer l'insertion professionnelle à travers
            des collaborations avec les entreprises.
          </p>
          <p>
            Merci de remplir ce formulaire pour nous faire part de vos intentions.
          </p>
        </div>

        {/* Formulaire */}
        <div style={{
          flex: '1',
          minWidth: '300px',
          maxWidth: '500px',
          backgroundColor: '#f9f9f9',
          padding: '2rem',
          borderRadius: '10px',
          boxShadow: '0 0 15px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#333' }}>
            Formulaire de Partenariat
          </h2>

          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
              Société :
              <select
                name="societe"
                value={formData.societe}
                onChange={handleChange}
                required
                style={selectStyle}
              >
                <option value="">-- Sélectionnez --</option>
                <option value="testeur">Testeur</option>
                <option value="offre de stage">Offre de stage</option>
                <option value="offre d'emploi">Offre d'emploi</option>
                <option value="autre">Autre</option>
              </select>
            </label>

            <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
              Demande d'emploi :
              <select
                name="demande"
                value={formData.demande}
                onChange={handleChange}
                required
                style={selectStyle}
              >
                <option value="">-- Sélectionnez --</option>
                <option value="testeur">Testeur</option>
                <option value="offre de stage">Offre de stage</option>
                <option value="autre">Autre</option>
              </select>
            </label>

            <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
              Expert :
              <select
                name="expert"
                value={formData.expert}
                onChange={handleChange}
                required
                style={selectStyle}
              >
                <option value="">-- Sélectionnez --</option>
                <option value="second emploi">Second emploi</option>
                <option value="consulting">Consulting</option>
                <option value="autre">Autre</option>
              </select>
            </label>

            {(formData.societe === 'autre' || formData.demande === 'autre' || formData.expert === 'autre') && (
              <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
                Veuillez préciser :
                <input
                  type="text"
                  name="autreTexte"
                  value={formData.autreTexte}
                  onChange={handleChange}
                  required
                  placeholder="Autre à préciser"
                  style={inputStyle}
                />
              </label>
            )}

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '0.75rem',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                marginTop: '1rem'
              }}
            >
              Envoyer
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

const selectStyle = {
  display: 'block',
  width: '100%',
  padding: '0.5rem',
  marginTop: '0.5rem',
  borderRadius: '5px',
  border: '1px solid #ccc'
};

const inputStyle = {
  display: 'block',
  width: '100%',
  padding: '0.5rem',
  marginTop: '0.5rem',
  borderRadius: '5px',
  border: '1px solid #ccc'
};

export default Employabilite;
